<div *ngIf="isLoading" class="iframe-loader">
  <div class="spinner"></div>
  <p>Loading...</p>
</div>

<iframe
  #myIframe
  [src]="iframeUrl"
  width="100%"
  height="100%"
  frameborder="0"
  style="min-height: 100vh; border: none;"
></iframe>
